module.exports = __webpack_public_path__ + "static/media/Lens-Lilac_TW.39383b62.png";